import React from 'react';
import { useSelector } from 'react-redux';
import { numericFormatter } from 'react-number-format';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

export default function PaymentMethodUpdate({ activityData, lastRegister, newRegister }) {
  const { selects } = useSelector(state => state.filters);

  const primitivePaymentMethods = selects?.find(select => select?.id == 'primitivePaymentMethod')?.options;
  const accounts = selects?.find(select => select?.id == 'account')?.options;

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Registro Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('primitivePaymentMethodId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Método de Pagamento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {primitivePaymentMethods?.find(paymentMethod => +paymentMethod?.value == +lastRegister?.primitivePaymentMethodId)?.label || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('paymentMethodName') && (
                <Row>
                  <Typography color='primary'>
                    <b>Nome</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.paymentMethodName || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('receivingFee') && (
                <Row>
                  <Typography color='primary'>
                    <b>Taxa</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {numericFormatter(lastRegister?.receivingFee?.toString() || '0', { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('accountId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Conta Destino</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {accounts?.find(account => +account?.value == +lastRegister?.accountId)?.label || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('status') && (
                <Row>
                  <Typography color='primary'>
                    <b>Status</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.status == 1 ? 'Ativado' : 'Desativado'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('codigoConveniado') && (
                <Row>
                  <Typography color='primary'>
                    <b>Codigo Conveniado</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.codigoConveniado || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('usuario') && (
                <Row>
                  <Typography color='primary'>
                    <b>Usuário</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.usuario || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('senha') && (
                <Row>
                  <Typography color='primary'>
                    <b>Senha</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.senha || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('idEC') && (
                <Row>
                  <Typography color='primary'>
                    <b>idEC</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.idEC || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('codigoEstabelecimento') && (
                <Row>
                  <Typography color='primary'>
                    <b>codigoEstabelecimento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.codigoEstabelecimento || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('hash') && (
                <Row>
                  <Typography color='primary'>
                    <b>hash</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.hash || '--'}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Novo Registro</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('primitivePaymentMethodId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Método de Pagamento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {primitivePaymentMethods?.find(paymentMethod => +paymentMethod?.value == +newRegister?.primitivePaymentMethodId)?.label || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('paymentMethodName') && (
                <Row>
                  <Typography color='primary'>
                    <b>Nome</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {newRegister?.paymentMethodName || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('receivingFee') && (
                <Row>
                  <Typography color='primary'>
                    <b>Taxa</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {numericFormatter(newRegister?.receivingFee?.toString() || '0', { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('accountId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Conta Destino</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {accounts?.find(account => +account?.value == +newRegister?.accountId)?.label || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('status') && (
                <Row>
                  <Typography color='primary'>
                    <b>Status</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.status == 1 ? 'Ativado' : 'Desativado'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('codigoConveniado') && (
                <Row>
                  <Typography color='primary'>
                    <b>Codigo Conveniado</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.codigoConveniado || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('usuario') && (
                <Row>
                  <Typography color='primary'>
                    <b>Usuário</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.usuario || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('senha') && (
                <Row>
                  <Typography color='primary'>
                    <b>Senha</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.senha || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('idEC') && (
                <Row>
                  <Typography color='primary'>
                    <b>idEC</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.idEC || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('codigoEstabelecimento') && (
                <Row>
                  <Typography color='primary'>
                    <b>codigoEstabelecimento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.codigoEstabelecimento || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('hash') && (
                <Row>
                  <Typography color='primary'>
                    <b>hash</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.hash || '--'}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}